// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/graphic.scss';
import '../public/numbers/colon.svg';
import '../public/numbers/num_0.svg';
import '../public/numbers/num_1.svg';
import '../public/numbers/num_2.svg';
import '../public/numbers/num_3.svg';
import '../public/numbers/num_4.svg';
import '../public/numbers/num_5.svg';
import '../public/numbers/num_6.svg';
import '../public/numbers/num_7.svg';
import '../public/numbers/num_8.svg';
import '../public/numbers/num_9.svg';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

export let timestamp;

const params = new URLSearchParams(document.location.search);
timestamp = params.has('time') ? params.get('time') : '0130am';

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

function draw(initialWidth) {
  const container = select('#graphic');
  container.select('#hour-0').attr('src', `numbers/num_${timestamp[0]}.svg`);
  container.select('#hour-1').attr('src', `numbers/num_${timestamp[1]}.svg`);
  container.select('#minute-0').attr('src', `numbers/num_${timestamp[2]}.svg`);
  container.select('#minute-1').attr('src', `numbers/num_${timestamp[3]}.svg`);
  container.select('#am-pm-label').text(((timestamp[4] + timestamp[5]).toUpperCase() === 'AM' ? 'A.M.' : 'P.M.'));

  // setTimeout(() => {
  //   container.select('#minute-1').attr('src', `numbers/num_${timestamp[3]}.svg`);
  // }, 1000);
}


const trackedObjects = document.querySelectorAll('.clock-container');

console.log(trackedObjects);

// Main section of code that tracks the objects
window.pymChild.onMessage('viewport-iframe-position', (parentInfo) => {
  // this gets the parent position on the page
  const positions = parentInfo.split(' ').map(pos => parseFloat(pos));
  const container = select('#graphic');

  // check position and if on screen add in the inview class
  trackedObjects.forEach((obj) => {
    const tp = obj.getBoundingClientRect().top;
    if (tp > 0) {
      const tpos = 1 - ((tp + positions[2]) / positions[1]);

      // toggle the inview class based on position
      if (tpos > 0.3) {
        // Show current time when in view
        container.select('#minute-0').attr('src', `numbers/num_${timestamp[2]}.svg`);
        container.select('#minute-1').attr('src', `numbers/num_${timestamp[3]}.svg`);
      } else {
        // Show previous minute when below 0.3 viewport
        let prevMinute0 = parseInt(timestamp[2]);
        let prevMinute1 = parseInt(timestamp[3]);

        // Subtract 1 minute
        if (prevMinute1 > 0) {
          prevMinute1 -= 1;
        } else {
          prevMinute1 = 9;
          if (prevMinute0 > 0) {
            prevMinute0 -= 1;
          } else {
            prevMinute0 = 5; // Minutes only go 0-59, so tens digit max is 5
          }
        }

        container.select('#minute-0').attr('src', `numbers/num_${prevMinute0}.svg`);
        container.select('#minute-1').attr('src', `numbers/num_${prevMinute1}.svg`);
      }
      // obj.classList.toggle('inview', (tpos > 0.2) & (tpos < 0.8));
    }
  });
});

// refresh to get the parent position info
setInterval(() => {
  window.pymChild.getParentPositionInfo();
  console.log('refresh successful');
}, 100);
